// Custom code: limit rows

if (!customElements.get("show-more-height")) {
  customElements.define(
    "show-more-height",
    class ShowMoreHeight extends HTMLElement {
      connectedCallback() {
        this.toggleBtn = this.querySelector(".show-more-height__toggle");
        if (!this.toggleBtn) {
          this.disable();
          return;
        }

        this.content = this.querySelector(".show-more-height__content");
        if (!this.content) {
          this.disable();
          return;
        }

        this.handleToggle = this.toggle.bind(this);
        this.toggleBtn.addEventListener("click", this.handleToggle);

        this.observer = new ResizeObserver(() => {
          this.initFeature();
        });
        this.observer.observe(this.content);
      }

      disconnectedCallback() {
        this.toggleBtn?.removeEventListener("click", this.handleToggle);
        this.observer?.disconnect();
        this.disable();
      }

      initFeature() {
        this.classList.remove("show-more-height--loading");

        const maxHeight = Number(this.dataset.maxHeight);
        const isOverflowing = this.content.scrollHeight > maxHeight;

        if (!isOverflowing) {
          this.disable();
          return;
        }

        this.classList.add("show-more-height--enabled");

        if (!this.initialInit) {
          this.classList.add("show-more-height--limited");
        }
        this.initialInit = true;
      }

      toggle() {
        this.classList.toggle("show-more-height--limited");
      }

      disable() {
        this.classList.remove(
          "show-more-height--loading",
          "show-more-height--enabled",
        );
      }
    },
  );
}
